<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,16C3.58,16,0,12.42,0,8C0,3.58,3.58,0,8,0C12.42,0,16,3.58,16,8C16,12.42,12.42,16,8,16C8,16,8,16,8,16ZM12,5C11.72,5,11.47,5.11,11.29,5.29C11.29,5.29,7,9.59,7,9.59C7,9.59,4.71,7.29,4.71,7.29C4.53,7.11,4.28,7,4,7C3.45,7,3,7.45,3,8C3,8.28,3.11,8.53,3.29,8.71C3.29,8.71,6.29,11.71,6.29,11.71C6.47,11.89,6.72,12,7,12C7.28,12,7.53,11.89,7.71,11.71C7.71,11.71,12.71,6.71,12.71,6.71C12.89,6.53,13,6.28,13,6C13,5.45,12.55,5,12,5C12,5,12,5,12,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'TickCircle',
} as DefineComponent
</script>
